import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';
import { ScrollView } from 'react-native-gesture-handler';

import { Modal, theme } from '@sg/garnish';

import { StripeCustomerSheet } from '@order/integrations-stripe';

export const PaymentMethodEditor = (props: PaymentMethodEditorProps) => {
  const { visible, onClose } = props;
  const { formatMessage } = useIntl();

  return (
    <Modal
      fitHeight
      size="small"
      visible={visible}
      accessibilityLabel={formatMessage(messages.a11yLabel)}
      onRequestClose={onClose}
    >
      <View style={styles.container}>
        <Modal.CloseBtn onPress={onClose} />

        <ScrollView>
          <StripeCustomerSheet
            redirectTo={`https://${window.location.host}/account/payment-and-gift-cards`}
            visible={visible}
            onClose={onClose}
          />
        </ScrollView>
      </View>
    </Modal>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  a11yLabel: {
    defaultMessage: 'Manage payment methods',
    description: 'Payment method editor | Modal Headline',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: theme.spacing['4'],
    paddingBottom: theme.spacing['2'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type PaymentMethodEditorProps = {
  visible: boolean;
  onClose: () => void;
};
